import { graphql, useStaticQuery } from "gatsby"

import { mapCountries } from "./service"
import { ResponseCatalog } from "./types"

interface CatalogGatsbyData {
  allCatalog: {
    edges: {
      node: ResponseCatalog
    }[]
  }
}
const useCatalogGatsbyData = () => {
  const { allCatalog } = useStaticQuery<CatalogGatsbyData>(graphql`
    query CatalogCsvQuery {
      allCatalog {
        edges {
          node {
            currencies
            catalog {
              category
              countries
              currency_codes
              card_image_path
              name
            }
          }
        }
      }
    }
  `)
  const { catalog, currencies } = allCatalog.edges[0].node
  return {
    catalogInitial: catalog.map(catalogItem => ({
      ...catalogItem,
      cardImagePath: catalogItem.card_image_path,
      logoImagePath: "",
      countries: mapCountries(catalogItem.countries),
      countryCodes: catalogItem.countries,
      currencyCodes: catalogItem.currency_codes,
    })),
    currencyInitial: currencies,
  }
}

export default useCatalogGatsbyData
